import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from 'libs/portal/src/layout/layout.component';
import { AuthGuardService } from 'libs/portal/src/services/auth-guard/auth-guard.service';
import { DeviceDetailsComponent } from '../tools/device-details/device-details.component';
import { CdrDevicesComponent } from './pages/cdr-devices/cdr-devices.component';
import { CdrDashboardPageComponent } from './pages/cdr-dashboard/cdr-dashboard.component';
import { CdrMapComponent } from './pages/map/cdr-map.component';

const routes: Routes = [
  {
    path: 'Dashboard',
    component: LayoutComponent,
    data: { breadcrumb: 'Dashboard' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: CdrDashboardPageComponent,
      },
    ],
  },
  {
    path: 'Devices',
    component: LayoutComponent,
    data: { breadcrumb: 'Devices' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: CdrDevicesComponent,
      },
      {
        path: 'Details',
        canActivate: [AuthGuardService],
        component: DeviceDetailsComponent,
        data: { breadcrumb: 'Details' },
      },
    ],
  },
  {
    path: 'Alerts',
    component: LayoutComponent,
    data: { breadcrumb: 'Alerts' },
    loadChildren: () => import('./pages/alerts/alerts.module').then((m) => m.AlertsModule),
  },
  {
    path: 'Map',
    component: LayoutComponent,
    data: { breadcrumb: 'Map' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: CdrMapComponent,
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CDRRoutingModule {}
